/* ArmadaMeds storefront refresh (Sep 2026).
   1) Delivery window: 1 business day handling + 2 business days transit ("most of the continental US").
      Order today -> arrives between today + 3 and today + 4 business days (weekends skipped; holidays not modelled).
   2) "Pairs well with" and cart "+ Add" buttons: add to cart through /cart/add.js, then ask the theme to refresh the cart. */
(function () {
  'use strict';

  function addBusinessDays(date, n) {
    var d = new Date(date.getTime());
    while (n > 0) {
      d.setDate(d.getDate() + 1);
      var day = d.getDay();
      if (day !== 0 && day !== 6) n -= 1;
    }
    return d;
  }

  function fmt(d) {
    return d.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' });
  }

  function etaText() {
    var now = new Date();
    return 'Arrives ' + fmt(addBusinessDays(now, 3)) + ' – ' + fmt(addBusinessDays(now, 4));
  }

  function fillEta(root) {
    var text = etaText();
    (root || document).querySelectorAll('[data-am-eta]').forEach(function (el) {
      if (el.getAttribute('data-am-eta-done') === text) return;
      var mode = el.getAttribute('data-am-eta');
      el.textContent = mode === 'long' ? text : text;
      el.setAttribute('data-am-eta-done', text);
    });
  }

  function refreshCart() {
    ['cart:refresh', 'cart:updated'].forEach(function (name) {
      document.documentElement.dispatchEvent(new CustomEvent(name, { bubbles: true }));
      document.dispatchEvent(new CustomEvent(name, { bubbles: true }));
    });
  }

  function addItems(ids) {
    return fetch((window.routes && window.routes.cartAddUrl ? window.routes.cartAddUrl : '/cart/add') + '.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: ids.map(function (id) { return { id: Number(id), quantity: 1 }; }) })
    }).then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); });
  }

  document.addEventListener('click', function (event) {
    var pairsBtn = event.target.closest('[data-am-pairs-add]');
    if (pairsBtn) {
      event.preventDefault();
      var box = pairsBtn.closest('.am-pairs');
      var ids = Array.prototype.map.call(box.querySelectorAll('[data-am-pair]:checked'), function (i) { return i.value; });
      if (!ids.length) return;
      pairsBtn.disabled = true;
      var label = pairsBtn.textContent;
      pairsBtn.textContent = 'Adding…';
      addItems(ids).then(function () {
        pairsBtn.textContent = 'Added to cart';
        refreshCart();
      }).catch(function () {
        pairsBtn.textContent = label;
      }).finally(function () {
        setTimeout(function () { pairsBtn.disabled = false; pairsBtn.textContent = label; }, 2500);
      });
      return;
    }

    var addBtn = event.target.closest('[data-am-add]');
    if (addBtn) {
      event.preventDefault();
      addBtn.disabled = true;
      addBtn.textContent = 'Adding…';
      addItems([addBtn.getAttribute('data-am-add')]).then(function () {
        addBtn.textContent = 'Added';
        refreshCart();
      }).catch(function () {
        addBtn.disabled = false;
        addBtn.textContent = '+ Add';
      });
    }
  });


  /* Pack-size swatches: add the price and per-unit price under each pack option. */
  function money(c) { return '$' + (c / 100).toFixed(2); }
  function packCount(label) {
    var m = /\bof\s+(\d+)/i.exec(label);
    return m ? parseInt(m[1], 10) : 1;
  }
  function decorateSwatches() {
    var data = document.querySelector('[data-am-variants]');
    if (!data) return;
    var variants;
    try { variants = JSON.parse(data.textContent); } catch (e) { return; }
    var radios = document.querySelectorAll('.block-swatch__radio[data-option-position]');
    if (!radios.length) return;
    var selected = {};
    radios.forEach(function (r) {
      if (r.checked) {
        var lab = document.querySelector('label[for="' + r.id + '"] .block-swatch__item-text');
        if (lab) selected[r.getAttribute('data-option-position')] = lab.textContent.trim();
      }
    });
    var maxN = 1;
    radios.forEach(function (r) {
      var t = document.querySelector('label[for="' + r.id + '"] .block-swatch__item-text');
      if (t) maxN = Math.max(maxN, packCount(t.textContent.trim()));
    });
    radios.forEach(function (r) {
      var label = document.querySelector('label[for="' + r.id + '"]');
      if (!label) return;
      var text = label.querySelector('.block-swatch__item-text');
      if (!text) return;
      var value = text.textContent.trim();
      var lower = value.toLowerCase();
      if (!(lower === 'each' || / of \d+/.test(lower))) return;
      var pos = parseInt(r.getAttribute('data-option-position'), 10) - 1;
      var match = variants.filter(function (v) {
        if (v.o[pos] !== value) return false;
        return v.o.every(function (ov, i) { return i === pos || !selected[i + 1] || selected[i + 1] === ov; });
      })[0];
      var old = label.querySelector('.am-swatch');
      if (old) old.remove();
      if (!match) return;
      var n = packCount(value);
      var box = document.createElement('span');
      box.className = 'am-swatch';
      box.innerHTML = '<span class="am-swatch__price">' + money(match.p) + '</span>' +
        (n > 1 ? '<span class="am-swatch__unit">' + money(Math.round(match.p / n)) + ' each</span>' : '');
      label.appendChild(box);
      if (n > 1 && n === maxN) {
        var best = document.createElement('span');
        best.className = 'am-swatch__best';
        best.textContent = 'Best value';
        box.appendChild(best);
      }
    });
    preselectLargestPack(radios);
  }

  var preselected = false;
  function preselectLargestPack(radios) {
    if (preselected) return;
    preselected = true;
    if (window.theme && window.theme.pageType !== 'product') return;
    if (/[?&]variant=/.test(location.search)) return;
    var bestRadio = null, bestN = 1;
    radios.forEach(function (r) {
      var t = document.querySelector('label[for="' + r.id + '"] .block-swatch__item-text');
      if (!t) return;
      var n = packCount(t.textContent.trim());
      if (n > bestN && !r.disabled) { bestN = n; bestRadio = r; }
    });
    if (bestRadio && !bestRadio.checked) {
      var go = function () {
        var lab = document.querySelector('label[for="' + bestRadio.id + '"]');
        if (lab && !bestRadio.checked) lab.click();
      };
      if (document.readyState === 'complete') { setTimeout(go, 0); } else { window.addEventListener('load', function () { setTimeout(go, 50); }); }
    }
  }

  var pending = false;
  var observer = new MutationObserver(function () {
    if (pending) return;
    pending = true;
    requestAnimationFrame(function () { pending = false; observer.disconnect(); fillEta(); placeholders(); decorateSwatches(); updateSticky(); observer.observe(document.body, { childList: true, subtree: true }); });
  });

  function placeholders() {
    document.querySelectorAll('input[type="search"], input[name="q"]').forEach(function (i) {
      if (!i.getAttribute('data-am-ph')) { i.setAttribute('placeholder', 'Search by product, brand, or REF / part number'); i.setAttribute('data-am-ph', '1'); }
    });
  }

  var sticky = null;
  function setupSticky() {
    if (!window.theme || window.theme.pageType !== 'product' || sticky) return;
    var form = document.querySelector('.product-block-list__item--info form.product-form');
    var btn = form && form.querySelector('button[type="submit"]');
    if (!btn || !('IntersectionObserver' in window)) return;
    sticky = document.createElement('div');
    sticky.className = 'am-sticky';
    sticky.innerHTML = '<div class="am-sticky__info"><span class="am-sticky__price"></span><span class="am-sticky__pack"></span></div><button type="button" class="am-sticky__btn">Add to cart</button>';
    document.body.appendChild(sticky);
    sticky.querySelector('.am-sticky__btn').addEventListener('click', function () {
      var real = document.querySelector('.product-block-list__item--info form.product-form button[type="submit"]');
      if (real) real.click();
    });
    stickyIO = new IntersectionObserver(function (entries) {
      var e = entries[entries.length - 1];
      sticky.classList.toggle('is-visible', !e.isIntersecting && e.boundingClientRect.top < 0);
    });
    stickyBtn = btn;
    stickyIO.observe(btn);
    updateSticky();
  }
  var stickyIO = null, stickyBtn = null;
  function updateSticky() {
    if (!sticky) return;
    if (!stickyBtn || !stickyBtn.isConnected) {
      var nb = document.querySelector('.product-block-list__item--info form.product-form button[type="submit"]');
      if (nb) { if (stickyBtn) stickyIO.unobserve(stickyBtn); stickyBtn = nb; stickyIO.observe(nb); }
    }
    var price = document.querySelector('.product-block-list__item--info .product-form__info-content .price, .product-block-list__item--info .price');
    var checked = document.querySelector('.product-block-list__item--info .block-swatch__radio:checked');
    var pack = checked && document.querySelector('label[for="' + checked.id + '"] .block-swatch__item-text');
    sticky.querySelector('.am-sticky__price').textContent = price ? price.textContent.replace(/[^$0-9.,]/g, '') : '';
    sticky.querySelector('.am-sticky__pack').textContent = pack ? pack.textContent.trim() : '';
  }

  function start() {
    placeholders();
    fillEta();
    decorateSwatches();
    setupSticky();
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
